import React from "react";

import MyIntro from "../../components/myintro";
import Content from "../../components/content";
export default function index() {
  return (
    <div className="fade-in">
      <MyIntro />
      <Content />
    </div>
  );
}
